// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%2720 6 9 17 4 12%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-color-setting {
  width: calc(100% - 44px);
  margin: 10px 22px 0px;
}
.background-color-text {
  height: 20px;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: -5px;
  margin-top: 15px;
}
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.background-color-list {
  margin: 10px 0px 0px;
  width: 100%;
  min-height: 44px;
  padding-bottom: 6px;
}
.background-color-circle {
  display: inline-block;
  width: 35px;
  height: 35px;
  font-size: 20px;
  border-radius: 50%;
  opacity: 1;
  cursor: pointer;
  margin: 7px;
  margin-top: 3px;
  box-sizing: border-box;
  position: relative;
}
.theme-color-clear-button {
  cursor: pointer;
  margin-left: 10px;
  opacity: 0.8;
}
.background-color-circle .icon-more {
  position: absolute;
  margin: 8px;
}
.background-color-circle .icon-check {
  position: absolute;
  margin: 8px;
  font-weight: bold;
}
.background-color-circle .icon-close {
  position: absolute;
  margin: 6.5px;
  font-size: 18px;
  opacity: 0.7;
  float: right;
  font-size: 18px;
  cursor: pointer;
}
.theme-color-delete {
  float: right;
  font-size: 18px;
  cursor: pointer;
}
.active-color.background-color-circle {
  box-shadow:
    0 0 0 2.5px #fff,
    0 0 0 4.5px currentColor;
  outline: none;
}
.active-color.background-color-circle::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 55%;
}
`, "",{"version":3,"sources":["webpack://./src/components/readerSettings/themeList/themeList.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE;;4BAE0B;EAC1B,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yDAAwP;EACxP,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB","sourcesContent":[".background-color-setting {\n  width: calc(100% - 44px);\n  margin: 10px 22px 0px;\n}\n.background-color-text {\n  height: 20px;\n  width: 100%;\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: -5px;\n  margin-top: 15px;\n}\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.background-color-list {\n  margin: 10px 0px 0px;\n  width: 100%;\n  min-height: 44px;\n  padding-bottom: 6px;\n}\n.background-color-circle {\n  display: inline-block;\n  width: 35px;\n  height: 35px;\n  font-size: 20px;\n  border-radius: 50%;\n  opacity: 1;\n  cursor: pointer;\n  margin: 7px;\n  margin-top: 3px;\n  box-sizing: border-box;\n  position: relative;\n}\n.theme-color-clear-button {\n  cursor: pointer;\n  margin-left: 10px;\n  opacity: 0.8;\n}\n.background-color-circle .icon-more {\n  position: absolute;\n  margin: 8px;\n}\n.background-color-circle .icon-check {\n  position: absolute;\n  margin: 8px;\n  font-weight: bold;\n}\n.background-color-circle .icon-close {\n  position: absolute;\n  margin: 6.5px;\n  font-size: 18px;\n  opacity: 0.7;\n  float: right;\n  font-size: 18px;\n  cursor: pointer;\n}\n.theme-color-delete {\n  float: right;\n  font-size: 18px;\n  cursor: pointer;\n}\n.active-color.background-color-circle {\n  box-shadow:\n    0 0 0 2.5px #fff,\n    0 0 0 4.5px currentColor;\n  outline: none;\n}\n.active-color.background-color-circle::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 55%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
